const cards = [
    {
        icon: 'public-about-1',
        title: 'Легальный доход без&nbsp;статуса ИП',
        content:
            'Можно оказывать услуги без&nbsp;регистрации в качестве ИП. Доход подтверждается справкой из приложения.',
    },
    {
        icon: 'public-about-2',
        title: 'Выгодные налоговые&nbsp;ставки',
        content:
            '4% — с доходов от физлиц.<br/>6% — с доходов от юрлиц и ИП. Других обязательных платежей&nbsp;нет.',
    },
    {
        icon: 'public-about-3',
        title: 'Не нужно считать налог&nbsp;к уплате',
        content:
            'Налог начисляется автоматически в приложении. Уплата — не позднее 25 числа следующего месяца.',
    },
    {
        icon: 'public-about-4',
        title: 'Простая регистрация через интернет',
        content: 'Регистрация в мобильном приложении без визита в налоговую инспекцию.',
    },
    {
        icon: 'public-about-5',
        title: 'Чек формируется в приложении',
        content: 'Не надо покупать ККТ. Чек можно сформировать в мобильном приложении «Мой налог».',
    },
    {
        icon: 'public-about-6',
        title: 'Не нужно платить страховые взносы',
        content:
            'Нет обязанности уплачивать фиксированные взносы на пенсионное и медицинское страхование.',
    },
    {
        icon: 'public-about-7',
        title: 'Бонус для новых пользователей',
        content:
            'Налоговый вычет — 10 000 ₽. Ставка 4% уменьшается до 3%, ставка 6% уменьшается до 4%. Расчёт автоматический.',
    },
    {
        icon: 'public-about-8',
        title: 'Нет отчётов и деклараций',
        content:
            'Декларацию предоставлять не нужно. Учёт доходов ведётся автоматически в мобильном приложении.',
    },
    {
        icon: 'public-about-9',
        title: 'Совмещение с работой по трудовому договору',
        content:
            'Зарплата не учитывается при расчёте налога. Трудовой стаж по месту работы не прерывается.',
    },
] as const;

export default cards;
